'use client';

/**
 * CallBotHero — V3 hero for /callbot.
 *
 * Frames the invisible problem: customers have questions when you're
 * closed, and they don't wait. Names the product as the answer (a
 * voice widget on the loyalty card itself, powered by LouiseBot).
 *
 * Violet accent — CallBot is positioned alongside business-cards and
 * e-signature in the "feature page rotation".
 */

import Image from 'next/image';
import React from 'react';
import { Locale } from '../../../../i18n-config';
import { useTranslation } from '@/i18n/client';
import FeatureHero from '../_shared/sections/FeatureHero';

type Props = { lang: Locale };

const CALLBOT_IMAGE = 'https://cdn.1cdn.app/application/UMD/25100114505060_callbot_louisebot_sum.png';

const CallBotHero = ({ lang }: Props) => {
  const { t } = useTranslation(lang);

  const visual = (
    <Image
      src={CALLBOT_IMAGE}
      alt={t('CallBot/Hero/visual_alt')}
      width={840}
      height={840}
      sizes="(min-width: 1024px) 320px, 70vw"
      className="mx-auto h-auto w-3/4 max-w-[320px] rounded-3xl lg:w-full"
      priority
    />
  );

  return (
    <FeatureHero
      accent="#A78BFA"
      ariaLabel={t('CallBot/Hero/aria_label')}
      copy={{
        kicker: t('CallBot/Hero/badge'),
        headlineA: t('CallBot/Hero/title1'),
        headlineB: t('CallBot/Hero/title2'),
        subhead: t('CallBot/Hero/subtitle'),
        ctaPrimary: {
          label: t('CallBot/Hero/cta_primary'),
          href: `${process.env.NEXT_PUBLIC_DASHBOARD_BASE_URL}/register`,
        },
        ctaSecondary: {
          label: t('CallBot/Hero/cta_secondary'),
          href: '#how-it-works',
        },
      }}
      visual={visual}
      visualVisibleOnMobile
    />
  );
};

export default CallBotHero;
